import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {AuthApiService} from '../../Services/Api/Auth/auth-api.service';
import {RoutesEnum} from '../../Shared/Enum/routes.enum';
import {NavigationManagerService} from '../../Services/Platform/Ionic/navigation-manager.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthApiService);
  const navigationManager = inject(NavigationManagerService);

  if (auth.userIsLogIn()) {
    return true;
  }

  navigationManager.navigateRoot(RoutesEnum.onboarding, false);
  return false;
};
